module.exports = __webpack_public_path__ + "static/media/main2.989c19c9.jpg";